import React from 'react';
import FadeIn from '../components/ui/FadeIn';

const About = () => {
  return (
    <div className="pt-32 pb-20 bg-brand-cream overflow-hidden min-h-screen">
      <section className="container mx-auto px-6 max-w-7xl mb-32">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          
          <div className="lg:col-span-7 z-10">
            <FadeIn>
              <div className="w-16 h-1 bg-brand-accent mb-10"></div>
              <h1 className="text-6xl md:text-[5.5rem] font-serif leading-[1.05] mb-8 text-brand-dark">
                Die Visionärin <br/>
                <span className="text-brand-accent italic">Rukiye Amini.</span>
              </h1>
              <p className="text-xl md:text-2xl text-brand-text leading-relaxed max-w-2xl font-light">
                Ich helfe Frauen in der Beauty-Branche, aus ihrem Handwerk ein hochrentables und professionelles Imperium zu formen. Ohne sich verstellen zu müssen.
              </p>
            </FadeIn>
          </div>

          <div className="lg:col-span-5 relative">
            <FadeIn delay={0.2} direction="left">
              <div className="relative rounded-t-[10rem] rounded-b-3xl overflow-hidden aspect-[3/4] shadow-2xl">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/71cfb3f2c1c4f86ac7305ae07837e3ad7daeee2707deaf8d01a7201a7e4d6a6981486171b5a684215bdf4e70b20694be/images/aW1hZ2UvanBlZw==/020457bd14feb6d04738b0809f19c1c0.jpeg" 
                  alt="Rukiye Amini" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-brand-rose rounded-full -z-10 blur-3xl opacity-80"></div>
            </FadeIn>
          </div>
        </div>
      </section>

      <section className="py-32 bg-brand-dark text-white rounded-[4rem] shadow-2xl relative z-10 mx-4 md:mx-8 lg:mx-12 overflow-hidden">
        <div className="absolute top-0 right-0 w-[50vw] h-[50vw] bg-brand-accent/10 rounded-full blur-[120px] pointer-events-none"></div>
        
        <div className="container mx-auto px-6 max-w-4xl relative z-10">
          <FadeIn className="space-y-10 text-xl md:text-2xl text-white/80 leading-relaxed font-light">
            <p className="text-3xl md:text-4xl font-serif text-white leading-snug mb-12">
              Viele Frauen scheitern nicht an mangelndem Talent, sondern an Unsicherheit, fehlender Struktur oder mangelnder Sichtbarkeit im Premium-Segment.
            </p>
            
            <p>
              Rukiye Amini steht für modernes weibliches Empowerment, kompromisslose Professionalität und unternehmerisches Wachstum. Ihr Ziel ist es, Frauen dabei zu unterstützen, ihren wahren Wert zu erkennen und mutig zu kommunizieren.
            </p>

            <blockquote className="my-16 py-12 px-10 md:px-16 bg-white/5 backdrop-blur-lg rounded-[3rem] text-white italic font-serif text-3xl md:text-5xl border border-white/10 relative leading-tight">
              <span className="absolute -top-6 left-10 text-8xl text-brand-accent font-serif opacity-50">"</span>
              Es geht nicht darum, sich zu verstellen. Es geht darum, <span className="text-brand-accent">deine Expertise unübersehbar</span> zu machen.
            </blockquote>

            <p>
              Ich begleite dich dabei, Instagram strategisch als Verkaufskanal zu nutzen, wertige Kundinnen anzuziehen und deine Leistungen zu Preisen anzubieten, die deiner Qualität entsprechen.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-32">
        <div className="container mx-auto px-6 max-w-7xl">
          <FadeIn className="mb-20 text-center">
            <span className="text-brand-accent font-bold tracking-[0.2em] uppercase text-sm mb-4 block">Was mich antreibt</span>
            <h2 className="text-5xl md:text-6xl font-serif text-brand-dark">Meine Prinzipien</h2>
          </FadeIn>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-16">
            {[
              { id: "01", title: "Authentizität", desc: "Du sollst nicht jemand anderes werden. Wir schärfen deine echte Stärke und machen sie zu deinem Markenzeichen." },
              { id: "02", title: "Selbstbewusstsein", desc: "Wahrer Erfolg beginnt im Kopf. Lerne, größer zu denken und deine Preise ohne Zögern zu kommunizieren." },
              { id: "03", title: "Klarheit", desc: "Ein Premium-Business braucht glasklare Angebote, effiziente Prozesse und eine makellose Optik." },
              { id: "04", title: "Wachstum", desc: "Sichtbarkeit ist kein Zufall. Es ist die Kombination aus mutiger Strategie und konstanter Umsetzung." }
            ].map((value, idx) => (
              <FadeIn key={idx} delay={idx * 0.1} className="group border-t border-brand-dark/10 pt-8 relative">
                <div className="absolute top-8 right-0 text-brand-accent/20 font-serif text-8xl font-bold transition-transform duration-500 group-hover:-translate-y-4">{value.id}</div>
                <h3 className="text-3xl font-serif mb-4 text-brand-dark relative z-10">{value.title}</h3>
                <p className="text-brand-text text-lg leading-relaxed max-w-md font-light relative z-10">{value.desc}</p>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;